import { TableColumn } from '@shared/interface/table.interface';

export const PROGRAM_TARGET_TABLE_COLUMNS: TableColumn[] = [
  {
    key: 'program_name',
    title: 'NAMA TARGET',
    isSortable: false,
  },
  {
    key: 'period',
    title: 'PERIODE',
    isSortable: false,
  },
  {
    key: 'total_invoice',
    title: 'TOTAL NILAI INVOICE (SO)',
    isSortable: false,
  },
  {
    key: 'progress',
    title: 'PROGRES PROGRAM',
    isSortable: false,
  },
  {
    key: 'budget',
    title: 'ESTIMASI BUDGET HADIAH',
    isSortable: false,
  },
  {
    key: 'status',
    title: 'STATUS',
    isSortable: false,
  },
];
